// eslint-disable-next-line max-len
const HUNDRED_BRICKS_PLATFORM_SECTION_NAMES = {
    myBricksOnSale: 'myBricksOnSale',
    myBricksPortfolio: 'myBricksPortfolio',
    myBricksSold: 'myBricksSold',
    onSalePropertyList: 'onSalePropertyList',
    crowdfundingPropertyList: 'crowdfundingPropertyList'
};
export default HUNDRED_BRICKS_PLATFORM_SECTION_NAMES;
